import { createFileRoute } from "@tanstack/react-router"
import { LegalPage } from "@/components/legal/legal-page"

export const Route = createFileRoute("/terms")({ component: Terms })

function Terms() {
  return (
    <LegalPage title="Terms of service" updated="17 September 2026">
      <p>These terms apply to members of the business that operates this Vienna installation and to the way it is used with Meta's platforms.</p>
      <h2>Use of the service</h2>
      <ul>
        <li>The service is provided to the business's own team to manage messages and comments on accounts the business controls.</li>
        <li>Members must hold the role the business assigned them; roles decide who may reply, publish automations, send campaigns and export customer data.</li>
        <li>Messages sent through the service must comply with Meta's Platform Terms and Messenger and Instagram messaging policies, including the messaging window and consent requirements for marketing messages.</li>
      </ul>
      <h2>Customer data</h2>
      <ul>
        <li>Customer conversations are processed as described in the privacy policy and only for serving those customers.</li>
        <li>Exports and deletions are recorded in an audit log with the acting member's name.</li>
      </ul>
      <h2>Availability</h2>
      <p>The service is offered as is. Delivery of messages depends on Meta's platforms; the service records delivery uncertainty rather than assuming success.</p>
      <h2>Changes</h2>
      <p>The business may update these terms; the date above records the latest revision.</p>
    </LegalPage>
  )
}
